export default "__VITE_ASSET__C0CBh3Ah__"